import React, { useEffect, useState } from "react";
import { acarolelist, roleList } from "../../../services/master";
import {
  academylist,
  academyusercreate,
  academyusergetdetail,
  getuserpassword,
} from "../../../services/admin";
import Select from "react-select";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export const AcademyUser = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [urllink, setUrllink] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");

  const [phone, setPhone] = useState("");

  const [atype, setAType] = useState("1");
  const [alist, setAList] = useState([]);

  const [acaid, setAcaId] = useState("");
  const [acalist, setAcaList] = useState([]);

  const [arole, setARole] = useState("");
  const [rlist, setRList] = useState([]);

  const [aerrmsg, setAErrMsg] = useState("");
  const [aerror, setAError] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/")[2];
    setUrllink(path);
    acarolelist().then((res) => {
      if (res.status === true) {
        setAList(res.data);
      }
    });

    academylist().then((res) => {
      if (res.status === true) {
        if (res.data.details.length > 0) {
          let arr = [];
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label: res.data.details[i].name,
            });
          }
          setAcaList(arr);
        }
      }
    });

    roleList().then((res) => {
      if (res.status === true) {
        setRList(res.data);
      }
    });

    if (path === "academyuserdetail") {
      academyusergetdetail(id).then((res) => {
        if (res.status === true) {
          setName(res.data.details.name);
          setEmail(res.data.details.email);

          setPhone(res.data.details.phone);
          setAType(res.data.details.academy_type);

          academylist().then((res1) => {
            if (res1.status === true) {
              if (res1.data.details.length > 0) {
                let arr = [];
                for (let i = 0; i < res1.data.details.length; i++) {
                  if (res1.data.details[i].id === res.data.details.academy_id) {
                    arr.push({
                      value: res1.data.details[i].id,
                      label: res1.data.details[i].name,
                    });
                  }
                }
                setAcaId(arr[0]);
              }
            }
          });
          const temp = new FormData();
          temp.append("id", id);
          getuserpassword(temp).then((res1) => {
            if (res1.status === true) {
              setPass(res1.data.decrypted_password);
            }
          });
          setARole(res.data.details.role);
        }
      });
    }
  }, [location.pathname]);
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPhone(e.target.value);
    }
  };

  function adduser(e) {
    e.preventDefault();
    setAError(true);
    setAErrMsg("");
    var valid = "";
    if (
      name !== "" &&
      email !== "" &&
      pass !== "" &&
      phone !== "" &&
      atype !== "" &&
      acaid !== "" &&
      arole !== ""
    ) {
      if (phone !== "") {
        if (phone.length < 10) {
          valid = "Phone Number should be 10 digits";
          setAErrMsg("Phone Number should be 10 digits");
        }
      }
      if (email !== "") {
        let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        if (!regEmail.test(email)) {
          valid = "Please Enter a valid Email";
          setAErrMsg("Please Enter a valid Email");
        }
      }

      if (valid === "") {
        if (pass.length >= 8) {
          // if (pass.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/)) {
            setLoading(true);

            const temp = new FormData();
            temp.append("name", name);
            temp.append("email", email);
            temp.append("password", pass);
            temp.append("phone", phone);
            temp.append("academy_type", atype);
            temp.append("academy_id", acaid.value);
            temp.append("role", arole);
            if (urllink === "academyuserdetail") {
              temp.append("id", id);
            }
            academyusercreate(temp).then((res) => {
              if (res.status === true) {
                setLoading(false);
                navigate("/settings/academyuserlist");
                toast.success(res.message);
              } else {
                setLoading(false);
                toast.error(res.message);
              }
            });
          // } else {
          //   setAErrMsg(
          //     "Password should be minimum 8 character with atleast 1 number, 1 lowercase character (a-z) and 1 uppercase character (A-Z)"
          //   );
          // }
        } else {
          setAErrMsg("Password should be minimum 8 character");
        }
      }
    }
  }

  function handleAca(e) {
    if (e !== null) {
      setAcaId(e);
    } else {
      setAcaId("");
    }
  }

  const [loading, setLoading] = useState(false);

  function LetterOnly(eve) {
    if (/^[a-zA-Z\s]*$/.test(eve.key)) {
      return true;
    } else {
      eve.preventDefault();
      return false;
    }
  }

  function onPasteLetter(e) {
    const str = e.clipboardData.getData("Text");
    const newStr = str.replace(/[+-.]/g, "");
    if (str !== newStr) {
      e.preventDefault();
    }
  }
  return (
    <div>
      <div className="page-header">
        <div>
          <h2 className="main-content-title tx-24 mg-b-5"> {urllink === "academyuserdetail" ? "Academy User Detail" : "Add Academy User"}</h2>

          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Settings</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {urllink === "academyuserdetail" ? "Academy User Detail" : "Add Academy User"}
            </li>
          </ol>
        </div>
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}

      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">
                {urllink === "academyuserdetail" ? "Academy User Detail" : "Add Academy User"}
              </h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Name
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Name"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                      onKeyPress={LetterOnly}
                      onPaste={onPasteLetter}
                    />
                    {aerror && name === "" && (
                      <span className="text-danger">Please Enter Name</span>
                    )}
                  </div>
                </div>

                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Email (Username)<span className="text-danger"> *</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Email (Username)"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                    {aerror && email === "" && (
                      <span className="text-danger">Please Enter Email</span>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Password<span className="text-danger"> *</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Password"
                      onChange={(e) => setPass(e.target.value)}
                      value={pass}
                      title="Your password should be minimum 8 character with atleast 1 number, 1 lowercase character (a-z) and 1 uppercase character (A-Z)"
                      maxLength={15}
                      onKeyDown={(e) => {
                        const allowed = /^[a-zA-Z0-9]$/;
                        if (
                          e.key.length === 1 && // only filter actual characters
                          !allowed.test(e.key)
                        ) {
                          e.preventDefault(); // block special characters
                        }
                      }}
                    />
                    {aerror && pass === "" && (
                      <span className="text-danger">Please Enter Password</span>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Phone Number
                      <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Phone Number"
                      onChange={handleChange}
                      value={phone}
                      maxLength={10}
                    />
                    {aerror && phone === "" && (
                      <span className="text-danger">
                        Please Enter Phone Number
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Academy Type
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      className="default-select  form-control wide"
                      value={atype}
                      onChange={(e) => setAType(e.target.value)}
                    >
                      <option value="" disabled>
                        Select Academy Type
                      </option>
                      {alist.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {aerror && atype === "" && (
                      <span className="text-danger">
                        Please Enter Academy Type
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Academy Name
                      <span className="text-danger"> *</span>
                    </label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy Name"
                      value={acaid}
                      options={acalist}
                      onChange={handleAca}
                      isSearchable={true}
                      isClearable
                      hidden
                    />
                    {aerror && acaid === "" && (
                      <span className="text-danger">
                        Please Enter Academy Name
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      User Role
                      <span className="text-danger"> *</span>
                    </label>
                    <select
                      className="default-select  form-control wide"
                      value={arole}
                      onChange={(e) => setARole(e.target.value)}
                    >
                      <option value="" disabled>
                        Select User Role
                      </option>
                      {rlist.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {aerror && arole === "" && (
                      <span className="text-danger">
                        Please Enter User Role
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {aerrmsg !== "" && <span className="text-danger">{aerrmsg}</span>}
              <div className="res-right mt-2 me-4">
                <button className="btn btn-success" onClick={adduser}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
